/* ELVARA - "Buy it now" on product cards.

   Dawn's quick-add adds to the cart and leaves you on the grid. This adds a
   second button that adds the item AND goes straight to checkout, so a shopper
   can buy from the listing without ever opening the product page.

   Only single-variant cards get it. A multi-variant card shows "Choose options"
   because there is no single variant id to buy - sending those straight to
   checkout would be guessing a variant on the customer's behalf.

   Sizing lives in elv-cards.css, not here: the button must never be wider than
   its card (see that file for the measured overflow it fixes).

   Progressive enhancement: if this script fails, the normal add-to-cart button
   is untouched. */
(function () {
  'use strict';

  var isArabic = (document.documentElement.lang || '').indexOf('ar') === 0;
  var LABEL = isArabic ? 'اشترِ الآن' : 'Buy it now';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function enhance(form) {
    if (form.dataset.elvBuyNow) return;

    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('.quick-add__submit');
    if (!idInput || !idInput.value || !submit) return;
    if (submit.hasAttribute('disabled')) return; // sold out

    form.dataset.elvBuyNow = '1';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--secondary elv-buy-now';
    btn.textContent = LABEL;
    btn.style.marginTop = '0.6rem';

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add to cart failed: ' + res.status);
          // root() already carries the /ar/ prefix, so checkout stays in-locale.
          window.location.href = root() + 'checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    });

    submit.parentNode.insertBefore(btn, submit.nextSibling);
  }

  function scan() {
    var forms = document.querySelectorAll('.quick-add product-form form');
    for (var i = 0; i < forms.length; i++) enhance(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  /* Filtering, sorting and pagination re-render the grid, so re-scan when new
     nodes land. Debounced - the observer fires a lot during a facet update. */
  var pending = null;
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        if (pending) clearTimeout(pending);
        pending = setTimeout(scan, 150);
        return;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
